module.exports = __webpack_public_path__ + "static/img/2飞鹰超华.de2cc10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/2飞鹰超华.jpg
// module id = e8oD
// module chunks = 1